module.exports = __webpack_public_path__ + "img/right.eba95181.png";